import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndexMenuButtonComponent } from './index-menu-button.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { RouterModule } from '@angular/router';
import { PropertyMassUpdateModule } from '../property-mass-update/property-mass-update.module';
import { ExportXlsModule } from 'app/components/export-xls/export-xls.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { PropertiesPrintEmailModule } from '../../properties-print-email/properties-print-email.module';
import { ImportConfirmModalModule } from 'app/components/import-confirm-modal/import-confirm-modal.module';
import { PropertiesAddToPortalModule } from '../properties-add-to-portal/properties-add-to-portal.module';
import { AttachmentExportDialogModule } from 'app/components/attachment-export-dialog/attachment-export-dialog.module';
import { CustomFieldsModule } from '../custom-fields/custom-fields.module';




@NgModule({
    declarations: [IndexMenuButtonComponent],
    imports: [
        CommonModule,
        FuseSharedModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatMenuModule,
        RouterModule,
        MatDialogModule,
        PropertyMassUpdateModule,
        MatSnackBarModule,
        ExportXlsModule,
        PropertiesPrintEmailModule,
        ImportConfirmModalModule,
        PropertiesAddToPortalModule,
        AttachmentExportDialogModule,
        CustomFieldsModule
    ],
    exports: [IndexMenuButtonComponent]
})
export class IndexMenuButtonModule { }
